<template>
  <div :id="`modal-${modalId}`">
    <MadModal
      :id="modalId"
      :data-cy="`${modalId}-modal`"
      :options="options"
      @opened="onOpened"
      @closed="onClosed"
    >
      <div class="modal-body">
        <b-tabs
          v-model="tabIndex"
          no-key-nav
        >
          <template>
            <b-tab :title="`${this.$i18n.t('JSON.common-strings')}`">
              <div class="v-table">
                <TableServer type="commonStrings" />
              </div>
            </b-tab>
            <b-tab :title="`${this.$i18n.t('JSON.add-common-string')}`">
              <CommonStringForm v-if="fetcherAdminSchemas.forms['CommonString']" />
            </b-tab>
            <b-tab
              v-if="commonStringId !== null && fetcherAdminCommonString.id > 0"
              :title="`${this.$i18n.t('JSON.common-string')}#${commonStringId}`"
            >
              <CommonStringForm
                v-if="fetcherAdminSchemas.forms['CommonString']"
                :common-string="fetcherAdminCommonString"
                mode="edit"
              />
            </b-tab>
          </template>
        </b-tabs>
      </div>
    </MadModal>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import formHelpers from '@/mixins/admin/helpers/form-helpers';
import modalHelpers from '@/mixins/admin/helpers/modal-helpers';

export default {

  components: {
    MadModal: () => import('@/components/MadModal'),
    CommonStringForm: () => import('@/components/admin/fetcher/modals/forms/CommonStringForm'),
  },

  mixins: [
    formHelpers, //
    modalHelpers,
  ],

  props: {
    commonStringId: {
      type: Number,
      default: () => 0,
    },
  },

  data() {
    return {
      options: {
        width: '75%',
        //   height: '95%',
      },
    };
  },

  computed: {
    ...mapState({
      fetcherAdminCommonString: (state) => state.fetcherAdminCommonString.fetcherAdminCommonString,
    }),

    modalId() {
      return 'commonString';
    },
  },

  watch: {
    commonStringId(newValue) {
      if (newValue !== null) {
        this.loadFetcherAdminCommonString();
      }
    },

  },

  methods: {
    ...mapActions(['getFetcherAdminCommonString']),

    async loadFetcherAdminCommonString() {
      try {
        await this.getFetcherAdminCommonString({
          params: {
            wpid: this.commonStringId,
          },
        });

        // console.log('common-string', this.common-string);

        // success
        // console.log('success loading common-string!');
      } catch (error) {
        // error
        // console.log('error loading common-string!');
      }
    },

    onOpened() {
      if (this.commonStringId !== null) {
        this.loadFetcherAdminCommonString();
      }

      this.modalOpened();
    },

    onClosed() {
      this.modalClosed();
    },
  },
};
</script>
